(function () {
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.cart-drawer-rec-card__form');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    var submitBtn = form.querySelector('.cart-drawer-rec-card__add');
    if (submitBtn) {
      submitBtn.disabled = true;
    }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || 'Unable to add item to cart.');
          });
        }
        return response.json();
      })
      .then(function () {
        if (window.SideCart && typeof window.SideCart.updateSideCart === 'function') {
          window.SideCart.updateSideCart(true);
          return;
        }
        window.location.href = '/cart';
      })
      .catch(function (error) {
        if (submitBtn) {
          submitBtn.disabled = false;
        }
        console.warn('[CartDrawerRecommendations]', error);
      });
  });
})();
